import { initActivateSlideBtns } from './works-with-integration-features-slider/works-with-integration-features-slider';
import { initCollapsibleArea } from '../../scripts/utils/collapsibleArea';
import { initActivateFeaturesThreeDevicesSlideBtns } from './works-with-integration-features-three-devices/works-with-integration-features-three-devices';
import { initWorksWithBuyNow } from './works-with-integration-buy-now/works-with-integration-buy-now';
import { initVideoAutoplayControls } from '../../scripts/utils/videoAutoplayControls/videoAutoplayControls';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

document.addEventListener('DOMContentLoaded', () => {
  initVideoAutoplayControls();
  initActivateSlideBtns();
  initActivateFeaturesThreeDevicesSlideBtns();
  initCollapsibleArea();
  initCollapsibleRows();
  initActionTracking();
  initWorksWithBuyNow();
});

// NOTE: Tracking events
function initActionTracking() {
  const featuresSlideControls = document.querySelectorAll(
    '[data-works-with-integrations-content-features-control]'
  );
  const hotjarSliderControlEventName = 'works_with_integration_feature_slider';

  featuresSlideControls.forEach((featuresSlideControl) => {
    featuresSlideControl.addEventListener('click', () => {
      window.HotJarHelper.triggerEvent(hotjarSliderControlEventName);
    });
  });
}
